var map = {
	"./5.png": "RXXY",
	"./5en.png": "AnQc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "i7OH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi ^\.\/5.*\.png$
// module id = i7OH
// module chunks = 0